require('./brokerMyInvestmentsOthersAssetsTable.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');
const Immutable = require('immutable');
const moment = require('moment');
const { withRouter } = require('react-router-dom');

// @ commons
const { OKTable } = require('commonsComponents/OKTable');
const { OKTableRow } = require('commonsComponents/OKTableRow');
const { OKTableCell } = require('commonsComponents/OKTableCell');
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');
const { OKButton } = require('components/commons/OKButton/OKButton');

// @helpers
const { getLanguage, formatText, FormattedText } = require('core/i18n').i18n;
const DateHelper = require('utilities/dateHelper');
const { getLastNChars } = require('utilities/stringHelper');
const { sendTextToClipBoard } = require('commonsUtilities/clipBoardHelper');
const { formatWithoutRound, formatCurrency, formatAmount } = require('utilities/currencyHelper');
const { valueOrHyphen, conditionalValueOrHyphen } = require('utilities/valueHelper');

// @constants
const { DATE_FORMAT_DAY_MONTH_SHORT, DATE_FORMAT_ES, HYPHEN, BROKER_TYPE_RIGHT_NEW_DECIMALS, MYPROFILE_BROKER_INTERNAL_TRANSFER_FUND, TYPE_PLANS, TYPE_FUNDS, TYPE_STOCKS, TYPE_WARRANTS, TYPE_ETFS, BROKER_NON_NATIONAL_IDS_VALIDATION_TYPES } = require('constants/index');

// @components
const BrokerMiFIDUSPersonButton = require('mifid/components/brokerMiFIDUSPersonButton/brokerMiFIDUSPersonButton');
const BrokerMyInvestmentsFundSellButton = require('components/broker/myInvestments/brokerMyInvestmentsFundSellButton/brokerMyInvestmentsFundSellButton');
const MarketableOperationOKButton = require('components/broker/commons/marketableOperationOKButton/marketableOperationOKButton');

const typeMatches = {
    ACCIONES: 'stocks',
    ETF: 'etfs',
    WARRANTS: 'warrants'
};

class BrokerMyInvestmentsOthersAssetsTable extends React.Component {
    constructor(props) {
        super(props);

        this.buildTooltipContent = this.buildTooltipContent.bind(this);
        this.buildContractNumber = this.buildContractNumber.bind(this);
        this.copyIbanToClipboard = this.copyIbanToClipboard.bind(this);
        this.buildBuyButton = this.buildBuyButton.bind(this);
        this.buildSellButton = this.buildSellButton.bind(this);
    }

    buildAmountCurrency(amount, currency) {
        if (amount===HYPHEN){
            return <span className="broker-products-table-row__amount">{amount}</span>
        } else {
            return (
                <span>
                    <span className="broker-products-table-row__amount">{amount} </span>
                    <span className="broker-products-table-row__currency">{currency}</span>
                </span>
            );
        }
    }

    buildContractNumber(immStock) {
        if (this.props.isContractSection || !immStock) {
            return null;
        }

        const contractForTooltip = immStock.get('contractForTooltip');
        const tooltipContent = this.buildTooltipContent(contractForTooltip);
        const textAndCroppedContractNumber = (
            <span className="broker-assets-table-others__row-contract-number-label">
                <span className="broker-products-table-row__contract-number-label">
                    {formatText('broker-myInvestmentsWrappedProductsTableContractLabel')}
                </span>
                <span className="broker-products-table-row__contract-number-value">
                    {getLastNChars(contractForTooltip)}
                </span>
            </span>
        );

        return (
            <div className="broker-products-table-row__contract-number">
                <OKTooltip
                    target={textAndCroppedContractNumber}
                    content={tooltipContent}
                    iconClass="icon-copiar"
                    placement="bottomLeft"
                />
            </div>
        );
    }

    buildFormattedDateAndTime(immStock, index) {
        const quoteTime = valueOrHyphen(immStock.getIn([index, 'quoteTime']));
        const date = immStock.getIn([index, 'quoteDate']);
        const quoteOriginalDate = DateHelper.buildFormattedDate(date, DATE_FORMAT_ES);
        let quoteDate = conditionalValueOrHyphen(date!==null, DateHelper.buildFormattedDate(date, DATE_FORMAT_DAY_MONTH_SHORT));

        if (moment().isSame(quoteOriginalDate, 'day')) {
            quoteDate = formatText('broker-todayMyInvestmentsProductsTable');
        }

        if (quoteDate===HYPHEN && quoteTime===HYPHEN){
            return HYPHEN;
        }

        return quoteDate + ', ' + quoteTime;
    }

    buildHeader() {
        return (
            <thead>
                <OKTableRow asHeader={true}>
                    <OKTableCell
                        asHeader={true}
                        className="broker-assets-table-others__name"
                        width="26%"
                    >
                        <FormattedText value="broker-productNameOthers"/>
                    </OKTableCell>
                    <OKTableCell
                        alignment="right"
                        asHeader={true}
                        className="broker-assets-table-others__titles"
                        width="7%"
                    >
                        <FormattedText value="broker-assetsSharesStocks"/>
                    </OKTableCell>
                    <OKTableCell
                        alignment="right"
                        asHeader={true}
                        className="broker-assets-table-others__average-price"
                        width="8%"
                    >
                        <FormattedText value="broker-assetsAveragePrice" />
                    </OKTableCell>
                    <OKTableCell
                        alignment="right"
                        asHeader={true}
                        className="broker-assets-table-others__capital"
                        width="11%"
                    >
                        <FormattedText value="broker-assetstInvestedCapital" />
                    </OKTableCell>
                    <OKTableCell
                        alignment="right"
                        asHeader={true}
                        className="broker-assets-table-others__quote"
                        width="15%"
                    >
                        <FormattedText value="broker-assetsNATStocks"/>
                    </OKTableCell>
                    <OKTableCell
                        alignment="right"
                        asHeader={true}
                        className="broker-assets-table-others__actual-value"
                        width="11%"
                    >
                        <FormattedText value="broker-assetsSharesActualValue"/>
                    </OKTableCell>
                    <OKTableCell
                        alignment="right"
                        asHeader={true}
                        className="broker-assets-table-others__earnings"
                        width="4%"
                    >
                        <FormattedText value="broker-assetsEarnings" />
                    </OKTableCell>
                    <OKTableCell
                        alignment="right"
                        asHeader={true}
                        className="broker-assets-table-others__in-wallet"
                        width="9%"
                    >
                        <FormattedText value="broker-assetsInWallet" />
                    </OKTableCell>
                    <OKTableCell
                        alignment="center"
                        asHeader={true}
                        className="broker-products-table__actions"
                        width="9%"
                    />
                </OKTableRow>
            </thead>
        );
    }

    buildQuotationLabel(immStock) {
        const quotationValue = immStock.get('quotationValue');

        if (quotationValue != null) {
            const quotationFormatted = formatAmount(quotationValue, getLanguage(), BROKER_TYPE_RIGHT_NEW_DECIMALS);
            return quotationFormatted;
        } else {
            return HYPHEN;
        }
    }

    buildAveragePriceEurLabelFor(immStock) {
        const averagePrice = immStock.getIn(['averagePriceEur','amount']);
        const averagePriceCurrency = immStock.getIn(['averagePriceEur','currency']);
        const averagePriceFormatted = formatWithoutRound(averagePrice, 3);
        return (this.buildAmountCurrencyEur(averagePriceFormatted, averagePriceCurrency));
    }

    buildAmountCurrencyEur(amount, currency) {
        return (
            <span className="broker-assets-table-row__second-row-eur">
                <span className="broker-assets-table-row__amount-eur">{amount} </span>
                <span className="broker-assets-table-row__currency-eur">{currency}</span>
            </span>
        );
    }

    buildInvestmentLabelFor(immStock) {
        const investment = immStock.get('investment');
        const profitability = immStock.get('earnings');

        if (investment == null || profitability == null) {
            return <FormattedText value="broker-myInvestmentsNotAvailableInitials"/>;
        }

        const investmentFormatted = formatWithoutRound(investment, 2);
        const investmentFormattedCurrency = immStock.get('investmentCurrency');

        return this.buildAmountCurrency(investmentFormatted, investmentFormattedCurrency);
    }

    buildProfitability(amountCurrency, percentage) {
        return (
            <div className="broker-products-table-row__earnings-row">
                {amountCurrency}
                <span className="broker-products-table-row__earnings-separator">|</span>
                <span className="broker-products-table-row__earnings-percentage">
                    {percentage}%
                </span>
            </div>
        );
    }

    buildProfitabilityLabelFor(immStock) {
        const profitability = immStock.get('earnings');
        const investment = immStock.get('investment');

        if (profitability == null || investment == null) {
            return <FormattedText value="broker-myInvestmentsNotAvailableInitials"/>;
        }

        const percentage = immStock.get('profitablePercentage');
        const currency = immStock.get('earningsCurrency');

        const profitabilityPercentage = formatWithoutRound(percentage, 2);
        const profitabilityFormatted = formatWithoutRound(profitability, 2);
        const amountCurrency = this.buildAmountCurrency(profitabilityFormatted, currency);
        return this.buildProfitability(amountCurrency, profitabilityPercentage);
    }

    getBuyButtonText(type) {
        switch (type) {
            case TYPE_STOCKS:
            case TYPE_WARRANTS:
            case TYPE_ETFS:
                return formatText('broker-myInvestmentsBuyLink');
            case TYPE_FUNDS:
                return formatText('broker-myInvestmentsSuscribeLink');
            case TYPE_PLANS:
                return formatText('broker-myInvestmentsContributeLink');
            default:
        }
    }

    buildBuyButton(immStock, handleBuy, finalType) {
        const marketable = immStock.get('marketable');
        const buyButtonLabel = this.getBuyButtonText(finalType);
        const disabledTooltipText = immStock.get('marketableTooltipText');

        return (
            <BrokerMiFIDUSPersonButton
                modifier="secondary"
                size="compact"
                onClick={() => handleBuy()}
                isinId={immStock.get('isin')}
                marketId={immStock.get('iso')}
                disabled={!marketable}
                disabledTooltipText={disabledTooltipText}
            >
                <div className="broker-products-table-row__buy-button">
                    {buyButtonLabel}
                </div>
            </BrokerMiFIDUSPersonButton>
        );
    }

    buildSellButton(immStock, sellButtonLabel, handleSell, finalType) {
        const marketable = immStock.get('marketable');
        const marketableTooltipText = immStock.get('marketableTooltipText');

        switch (finalType) {
            case TYPE_PLANS:
                return (
                    <OKButton modifier="ghost" size="compact" onClick={handleSell}>
                        <div>
                            {sellButtonLabel}
                        </div>
                    </OKButton>
                );
            case TYPE_FUNDS:
                const handleInternalTransferFundClick = () => {
                    if (immStock.get('totalValue') > 0) {
                        const fundId = immStock.get('id');
                        this.props.onPreSelectOriginInternalTransferFund(fundId);
                    }

                    this.props.history.push(MYPROFILE_BROKER_INTERNAL_TRANSFER_FUND);
                }

                return (
                    <BrokerMyInvestmentsFundSellButton
                        buttonLabel={sellButtonLabel}
                        onClickSell={handleSell}
                        onInternalTransferFundClick={handleInternalTransferFundClick}
                    />
                );
            default:
                return (
                    <MarketableOperationOKButton modifier="ghost" size="compact" onClick={handleSell} disabled={!marketable} disabledTooltipText={marketableTooltipText}>
                        <div className="broker-products-table-row__sell-button">
                            {sellButtonLabel}
                        </div>
                    </MarketableOperationOKButton>
                );
        }
    }

    getSellButtonText(type) {
        switch (type) {
            case TYPE_STOCKS:
            case TYPE_WARRANTS:
            case TYPE_ETFS:
                return formatText('broker-myInvestmentsSellLink');
            case TYPE_FUNDS:
                return formatText('broker-myInvestmentsReimburseLink');
            case TYPE_PLANS:
                return formatText('broker-myInvestmentsTraspassLink');
        }
    }


    getSellLink(type, value) {
        const isin = value.get('isin');
        const iso = value.get('iso');
        const emisionCode = value.get('emisionCode');
        const valueCode = value.get('valueCode');
        const customInstitutionSecurityId = value.get('customInstitutionSecurityId');
        const contractNumber = value.get('contractNumber') || value.get('numerodecontrato');

        switch (type) {
            case TYPE_FUNDS:
                return `/myprofile/broker/reimburseInvestment/${customInstitutionSecurityId}/${contractNumber}`;
            case TYPE_STOCKS:
                let stocksPath = `/myprofile/broker/${type}Sell/${isin}/${iso}/${emisionCode}/${valueCode}`;
                if (this.props.isContractSection) {
                    return stocksPath + `/${contractNumber}`;
                }
                return stocksPath;
            case TYPE_WARRANTS:
            case TYPE_ETFS:
            case TYPE_PLANS:
                return `/myprofile/broker/${type}Sell/${isin}/${iso}/${emisionCode}/${valueCode}`;
        }
    }

    getBuyLink(type, value) {
        const isin = value.get('isin');
        const iso = value.get('iso');
        switch (type) {
            case TYPE_FUNDS:
                const customInstitutionSecurityId = value.get('customInstitutionSecurityId');
                const fundId = value.get('id')
                return `/myprofile/broker/buyInvestmentFunds/${customInstitutionSecurityId}/${fundId}`;
            case TYPE_STOCKS:
            case TYPE_WARRANTS:
            case TYPE_ETFS:
            case TYPE_PLANS:
                return `/myprofile/broker/${type}Buy/${isin}/${iso}`;
        }
    }

    handleSell(immStock, sellLink, contractNumber, finalType) {
        const { history, setSellContract, isContractSection} = this.props;
        const choosedIsin = immStock.get('isin');
        if (isContractSection) {
            let contract = this.getContract('stocks', choosedIsin, contractNumber);
            const etfsContract = this.getContract('etfs', choosedIsin, contractNumber);
            contract = etfsContract ? etfsContract : contract;
            const warrantsContract = this.getContract('warrants', choosedIsin, contractNumber);
            contract = warrantsContract ? warrantsContract : contract;
            setSellContract(contract, false)
        }
        if (BROKER_NON_NATIONAL_IDS_VALIDATION_TYPES.indexOf(finalType) !== -1){
            history.push(sellLink);
        }
        this.props.onHandleBuyClick(sellLink);
    }

    handleBuy(buyLink, finalType) {
        if (BROKER_NON_NATIONAL_IDS_VALIDATION_TYPES.indexOf(finalType) !== -1){
            this.props.history.push(buyLink);
        }
        this.props.onHandleBuyClick(buyLink);
    }

    buildRows() {
        const { showCompleteList, immStocks } = this.props;
        const immStocksToDisplay = showCompleteList ? immStocks : immStocks.slice(0, 5);

        const rows = immStocksToDisplay.map((immStock, index) => {
            const name = immStock.get('name');
            const percentageInWallet = immStock.get('percentageInWallet');
            const formattedPercentageInWallet = percentageInWallet < 1 ? '< 1' : Math.round(percentageInWallet);
            const isin = valueOrHyphen(immStock.get('isin'));
            const marketName = valueOrHyphen(immStock.get('shortMarketName'));
            const currencyText = formatCurrency(immStock.get('quotationCurrency'));
            const priceLabel = this.buildQuotationLabel(immStock);
            const titles = valueOrHyphen(immStock.get('shares'));
            const dateAndTime = immStock.get('quotationValue') ? this.buildFormattedDateAndTime(immStocks, index) : null;
            const totalValue = immStock.get('totalValue');
            const value = conditionalValueOrHyphen(totalValue!==null, formatWithoutRound(totalValue, 2));
            const valueCurrency = immStock.get('totalValueCurrency');
            const formattedValue = this.buildAmountCurrency(value, valueCurrency);
            const averagePriceEurBlock = this.buildAveragePriceEurLabelFor(immStock);
            const formattedInvestment = this.buildInvestmentLabelFor(immStock);
            const formattedEarnings = this.buildProfitabilityLabelFor(immStock);
            const productType = immStock.get('productType');
            const finalType = typeMatches[productType] ? typeMatches[productType] : 0;
            let operateButtons;

            if(finalType) {
                const sellButtonLabel = this.getSellButtonText(finalType);
                const sellLink = this.getSellLink(finalType, immStock);
                const buyLink = this.getBuyLink(finalType, immStock);
                const contractNumber = immStock.get('numerodecontrato');
                const handleSell = this.handleSell.bind(this, immStock, sellLink, contractNumber, finalType);
                const handleBuy =  this.handleBuy.bind(this, buyLink, finalType);
                operateButtons = (
                    <div>
                        {this.buildSellButton(immStock, sellButtonLabel, handleSell, finalType)}
                        {this.buildBuyButton(immStock, handleBuy, finalType)}
                    </div>
                );
            }

            return (
                <OKTableRow className="broker-assets-table-others__row" key={index}>
                    <OKTableCell>
                        <div className="broker-assets-table-others__row-product-name">
                            {name}
                        </div>
                        <div className="broker-assets-table-others__row-market-isin">
                            {marketName} | <FormattedText value="broker-isinLabel" injectedStrings={[isin]}/>
                        </div>
                        {this.buildContractNumber(immStock)}
                    </OKTableCell>
                    <OKTableCell
                        alignment="right"
                        className="broker-assets-table-others__row-titles broker-products-table-row__cell-vertical-align--center"
                    >
                        {titles}
                    </OKTableCell>
                    <OKTableCell
                        alignment="right"
                        className="broker-products-table-row__average-price-row broker-products-table-row__cell-vertical-align--center"
                    >
                        <span>
                            <span className="broker-products-table-row__average-price-eur">
                                {averagePriceEurBlock}
                            </span>
                        </span>
                    </OKTableCell>
                    <OKTableCell
                        alignment="right"
                        className="broker-products-table-row__investment-row broker-products-table-row__cell-vertical-align--center"
                    >
                        <span>
                            <span className="broker-products-table-row__investment">
                                {formattedInvestment}
                            </span>
                        </span>
                    </OKTableCell>
                    <OKTableCell
                        alignment="right"
                        className="broker-assets-table-others__row-quote broker-products-table-row__cell-vertical-align--center"
                    >
                        <div className="broker-assets-table-others__row-quote-label">
                            {priceLabel} {currencyText}
                        </div>
                        <div className="broker-assets-table-others__row-quote-date-time-label">
                            {dateAndTime}
                        </div>
                    </OKTableCell>
                    <OKTableCell
                        alignment="right"
                        className="broker-products-table-row__earnings-row broker-products-table-row__cell-vertical-align--center"
                    >
                        <span>
                            <span className="broker-products-table-row__earnings">
                                {formattedEarnings}
                            </span>
                        </span>
                    </OKTableCell>
                    <OKTableCell
                        alignment="right"
                        className="broker-assets-table-others__row-actual-value broker-products-table-row__cell-vertical-align--center"
                    >
                        {formattedValue}
                    </OKTableCell>
                    <OKTableCell
                        alignment="right"
                        className="broker-assets-table-others__row-in-wallet broker-products-table-row__cell-vertical-align--center"
                    >
                        {formattedPercentageInWallet}%
                    </OKTableCell>
                    <OKTableCell
                        alignment="right"
                        className="broker-products-table-row__operate-column broker-products-table-row__action-vertical-align--center"
                    >
                        {operateButtons}
                    </OKTableCell>
                </OKTableRow>
            );
        });

        return (
            <tbody>
                {rows}
            </tbody>
        );
    }

    buildTooltipContentRow() {
        const title = formatText('broker-investmentsothersTableTitle');
        const content = formatText('broker-otherAssetTooltip');
        const iconInfo =(
            <OKTooltip
                content={content}
                placement="right"
            />

        );
        return (
            <tbody className="broker-assets-table-others__table">
                <OKTableRow className="broker-assets-table-others__row" >
                    <OKTableCell>
                        <span className="broker-assets-table-others__tooltip-title">
                            {title}
                        </span>
                        {iconInfo}
                    </OKTableCell>
                </OKTableRow>
            </tbody>
        );

    }

    buildTooltipContent(iban) {
        return (
            <span>
                {iban}
                <button
                    className="icon__tooltip icon-copiar"
                    onClick={() => this.copyIbanToClipboard(iban)}
                >
                </button>
            </span>
        );
    }

    copyIbanToClipboard(iban) {
        sendTextToClipBoard(iban);
    }

    render() {
        const header = this.buildHeader();
        const rows = this.buildRows();
        const tooltip = this.buildTooltipContentRow();

        return (
            <OKTable className="broker-assets-table-others">
                {header}
                {tooltip}
                {rows}
            </OKTable>
        );
    }
}

BrokerMyInvestmentsOthersAssetsTable.propTypes = {
    history: PropTypes.object.isRequired,
    immStocks: PropTypes.object,
    showCompleteList: PropTypes.bool,
    isContractSection: PropTypes.bool,
    onPreSelectOriginInternalTransferFund: PropTypes.func.isRequired,
    onHandleBuyClick: PropTypes.func,
    setSellContract: PropTypes.func.isRequired
};

BrokerMyInvestmentsOthersAssetsTable.defaultProps = {
    immStocks: Immutable.List(),
    showCompleteList: false,
    isContractSection: false
};

module.exports = withRouter(BrokerMyInvestmentsOthersAssetsTable);
